import React from 'react';
import PropTypes from 'prop-types';
import MaterialChip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

const Chip = (props) => {
  const StyledChip = styled(MaterialChip)({
    root: {
      color: 'white',
      backgroundColor: `${props.labelcolor} !important`,
      '&:hover': {
        backgroundColor: props.labelcolor,
        filter: 'brightness(120%)',
      },
      '&:active': {
        boxShadow: 'none',
        backgroundColor: props.labelcolor,
        borderColor: props.labelcolor,
      },
    },
    outlined: {
      color: `${props.labelcolor} !important`,
      border: `1px solid ${props.labelcolor}`,
      backgroundColor: `transparent !important`,
      '& .MuiChip-deleteIcon': {
        color: `${props.deleteiconcolor} !important`,
      },
    },
  });
  return <StyledChip {...props} />;
};

Chip.propTypes = {
  labelcolor: PropTypes.string,
  deleteiconcolor: PropTypes.string,
};

export default Chip;
